const darkBackgrounds = () =>
`
  <Divider layout={DIVIDERS.dark} />
`;

const darkSideBar = () =>
`
  <Divider layout={DIVIDERS.sidebar} />
`;

const defaultDivider = () =>
`
  <Divider />
`;

const lightBackgrounds = () =>
`
  <Divider layout={DIVIDERS.light} />
`;

const tooltipsAndPopovers = () =>
`
  <Divider layout={DIVIDERS.tooltips}
`;

const dividersTemplates = {
  darkBackgrounds: darkBackgrounds(),
  darkSideBar: darkSideBar(),
  defaultDivider: defaultDivider(),
  lightBackgrounds: lightBackgrounds(),
  tooltipsAndPopovers: tooltipsAndPopovers()
};

export default dividersTemplates;



// WEBPACK FOOTER //
// ./src/containers/elements/Dividers/constants/dividersTemplates.js